import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";


// Thunk for getting Add banners
export const getblogcategory = createAsyncThunk(
    'masters/add-blogcategory',
    async (_, { rejectWithValue }) => {
        try {
            const blogcategoryData = await GET(API.GET_BLOG_CATEGORY);
            return blogcategoryData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const getblog = createAsyncThunk(
    'masters/add-blog',
    async ({id,name}, { rejectWithValue }) => {
        try {
            const blogData = await GET(API.GET_BLOG + `/${id}?name=${name}`);
            return blogData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getblogById = createAsyncThunk(
    'masters/add-blogbyid',
    async (id, { rejectWithValue }) => {
        try {
            const blogbyidData = await GET(API.GET_BLOG_BY_ID + `/${id}`);
            return blogbyidData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk for getting Add banners
export const getlatestblog = createAsyncThunk(
    'masters/add-latestblog',
    async (_, { rejectWithValue }) => {
        try {
            const latestData = await GET(API.GET_LATEST_BLOG);
            return latestData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk for getting Add banners
export const gettopstatus = createAsyncThunk(
    'masters/add-topstatus',
    async (_, { rejectWithValue }) => {
        try {
            const topstatusData = await GET(API.GET_TOP_POST_STATUS);
            return topstatusData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Create the slice
const Slice = createSlice({
    name: "blog",
    initialState: {
        name: '',
        image: '',
        description: '',
        addBlogcategory: [],
        addBlog: [],
        addBlogById: [],
        addLatestblog: [],
        addTopstatus: [],
        error: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(getblogcategory.pending, (state) => {
                state.status = 'loading';
                console.log('State after pending', state);
            })
            .addCase(getblogcategory.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addBlogcategory = action.payload?.data || [];
                console.log('State after fulfilled', state);
            })
            .addCase(getblogcategory.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            })

            .addCase(getblog.pending, (state) => {
                state.status = 'loading';
                console.log('State after pending', state);
            })
            .addCase(getblog.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addBlog = action.payload?.data || [];
                console.log('State after fulfilled', state);
            })
            .addCase(getblog.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            })


            .addCase(getblogById.pending, (state) => {
                state.status = 'loading';
                console.log('State after pending', state);
            })
            .addCase(getblogById.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addBlogById = action.payload?.data || [];
                console.log('State after fulfilled', state);
            })
            .addCase(getblogById.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            })

            .addCase(getlatestblog.pending, (state) => {
                state.status = 'loading';
                console.log('State after pending', state);
            })
            .addCase(getlatestblog.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addLatestblog = action.payload?.data || [];
                console.log('State after fulfilled', state);
            })
            .addCase(getlatestblog.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            })

            .addCase(gettopstatus.pending, (state) => {
                state.status = 'loading';
                console.log('State after pending', state);
            })
            .addCase(gettopstatus.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addTopstatus = action.payload?.data || [];
                console.log('State after fulfilled', state);
            })
            .addCase(gettopstatus.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            });
    },
});

export default Slice.reducer;


